import { numberRequiredSchema, select2RequiredSchema, stringRequiredSchema, stringSchema } from "utils/validation/validationHelpers";
import { object } from 'yup';

const schema = object().shape({
	title: stringRequiredSchema,
	answers: stringRequiredSchema,
});

export default schema;